import { render, staticRenderFns } from "./addElementInline.vue?vue&type=template&id=28f62b5c&scoped=true&"
import script from "./addElementInline.vue?vue&type=script&lang=js&"
export * from "./addElementInline.vue?vue&type=script&lang=js&"
import style0 from "./addElementInline.vue?vue&type=style&index=0&id=28f62b5c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f62b5c",
  null
  
)

export default component.exports